import { CaretRight } from "@phosphor-icons/react";

import RelativeLink from "common/components/RelativeLink";

import { LEAD_LIST_SOURCE_TYPES } from "../../../constants";
import LeadListSourceTypeTag from "../../LeadListSourceTypeTag";

import type { LeadListSourceType } from "../../../types";

type SourceRowProps = {
  sourceType: LeadListSourceType;
} & ({ onClick: () => void } | { to: string });

export default function SourceRow({ sourceType, ...rest }: SourceRowProps) {
  const { label, subtitle } = LEAD_LIST_SOURCE_TYPES[sourceType];

  const content = (
    <>
      <LeadListSourceTypeTag type={sourceType} isCompact />
      <div className="flex flex-col lg:flex-row gap-1 grow lg:items-center">
        <span className="text-sm-bold mr-2">{label}</span>
        <p className="text-xs-medium flex-1 text-black-400">{subtitle}</p>
      </div>
      <CaretRight className="size-4 text-black-400" />
    </>
  );

  const commonClassname =
    "flex w-full items-center gap-3 hover:bg-black-100 border-b-black-150 border border-transparent last:border-0 p-3 text-left transition-colors first:rounded-t-3xl last:rounded-b-3xl bg-black-50";

  if ("to" in rest) {
    return (
      <RelativeLink to={rest.to} className={commonClassname}>
        {content}
      </RelativeLink>
    );
  }
  return (
    <button type="button" onClick={rest.onClick} className={commonClassname}>
      {content}
    </button>
  );
}
